import { render, staticRenderFns } from "./MarketingObjectDetailsView.vue?vue&type=template&id=f678a88e&scoped=true"
import script from "./MarketingObjectDetailsView.vue?vue&type=script&lang=js"
export * from "./MarketingObjectDetailsView.vue?vue&type=script&lang=js"
import style0 from "./MarketingObjectDetailsView.vue?vue&type=style&index=0&id=f678a88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f678a88e",
  null
  
)

export default component.exports